import React, { lazy } from 'react';
import { Switch, Route } from 'react-router-dom';

import Sitemap from 'src/components/Sitemap/Sitemap';
const Page = lazy(() => import('src/containers/Page/Page'));
const NotFound = lazy(() => import('src/containers/NotFound/NotFound'));
const PageRightSidebar = lazy(() => import('src/containers/Page/PageRightSidebar'));
const RouterRedirect = lazy(() => import('src/containers/RouterRedirect/RouterRedirect'));
const PrivateRoute = lazy(() => import('src/containers/PrivateRoute/PrivateRoute'));
const GuardRoute = lazy(() => import('src/containers/GuardRoute/GuardRoute'));
const LottoLobby = lazy(() => import('src/pages/LottoLobby/LottoLobby'));
const LottoDraw = lazy(() => import('src/pages/LottoDraw/LottoDraw'));
const RacingDetail = lazy(() => import('src/pages/RacingDetail/RacingDetail'));
const RacingLobby = lazy(() => import('src/pages/RacingLobby/RacingLobby'));
const SportsBetting = lazy(() => import('src/pages/SportsBetting/SportsBetting'));
const TopEvents = lazy(() => import('src/pages/SportsBetting/TopEvents'));
const AllMArkets = lazy(() => import('src/pages/SportsBetting/AllMarkets'));
const NextRaces = lazy(() => import('src/pages/NextRaces/NextRaces'));
const Preview = lazy(() => import('src/pages/Preview/Preview'));

export default function SiteRouting() {

  return (
    <Switch>
      { /* SITEMAP */ }
      <Route path="/sitemap" component={ Sitemap } />

      { /* SPORTS BETTING */ }
      <Route exact path="/sports-betting">
        <RouterRedirect to="/sports-betting/prematch" />
      </Route>
      <Route
        exact
        path="/sports-betting/top/:event"
        render={ () => <TopEvents /> }
      />
      <Route
        exact
        path="/sports-betting/events/:tournament/:code"
        render={ () => <AllMArkets /> }
      />
      <Route
        exact
        path="/sports-betting/:type"
        render={ () => <SportsBetting /> }
        sitemapIndex={ true }
        slugs={ [{ type: 'prematch' }, { type: 'live' }] }
        changefreq="always"
      />
      <Route
        exact
        path="/sports-betting/:id/markets"
        render={ () => <Page childComponent="MarketsGrid" /> }
      />

      { /* LOTTO */ }
      <Route
        exact
        path="/lotto"
        render={ () => <LottoLobby /> }
        sitemapIndex={ true }
        changefreq="always"
      />
      <GuardRoute
        path="/lotto/:tournamentCode/:eventId"
        render={ () => <LottoDraw /> }
      />

      { /* ACCOUNT */ }
      <PrivateRoute
        exact
        path={ ['/account', '/account/:tab'] }
        render={ () => <PageRightSidebar childComponent="Account" /> }
      />

      { /* STATIC */ }
      <Route
        exact
        path="/static/:slug"
        render={ () => <PageRightSidebar childComponent="Static" /> }
      />

      { /* RACING */ }
      <Route exact path="/racing">
        <RouterRedirect to="/racing/today" />
      </Route>
      <Route
        exact
        path="/racing/next-races"
        render={ () => <NextRaces /> }
        sitemapIndex={ true }
        changefreq="always"
      />
      <Route
        exact
        path="/racing/:type"
        render={ () => <RacingLobby /> }
        sitemapIndex={ true }
        slugs={ [{ type: 'yesterday' }, { type: 'today' }, { type: 'tomorrow' }] }
        changefreq="always"
      />
      <GuardRoute
        exact
        path={ ['/racing/:meetingCode/:event', '/racing/:meetingCode/:event/:tab', '/racing/:meetingCode/:event/:tab/:market'] }
        render={ () => <RacingDetail /> }
      />

      { /* BET ON GAMES */ }
      <Route
        path="/bet-on-games"
        render={ () => <PageRightSidebar childComponent="ComingSoon" /> }
      />

      { /* CONTENT LOBBIES */  }
      <Route
        exact
        path="/lobby/:slug"
        render={ () => <PageRightSidebar childComponent="ContentLobbies" /> }
      />

      { /* PREVIEW */  }
      <Route
        exact
        path="/preview"
        render={ () => <Preview /> }
      />

      { /* HOME */ }
      <Route exact path="/">
        <RouterRedirect to="/sports-betting/prematch" />
      </Route>

      <Route component={ NotFound } />
    </Switch>
  );
}
